export const MAPBOX_TOKEN = 'pk.eyJ1IjoiamRlb2xpdmUiLCJhIjoiY2p6aGNvb25uMHR0MDNucGlka2V1NHRpOCJ9.yKALxNb3NLxGBY9aL8Ofqg';
export const STYLE_STREETS = "streets-v11";
export const STYLE_SATELLITE = "satellite-v9";
export const STYLE_SATELLITE_STREETS = "satellite-streets-v11";
export const STYLE_OUTDOORS = "outdoors-v11";
export const STYLE_LIGHT = "light-v10";
export const STYLE_DARK = "dark-v10";
export const DEFAULT_ZOOM = 14
